//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import competitionApi from '@/api/competition'
import B5Login from '@/components/login/Login'
import CompetitionForm from '@/components/competition/CompetitionForm'
export default {
  async asyncData({ route, params, store, redirect }) {
    if (
      route.path.endsWith(`/${params.id}`) ||
      route.path.endsWith(`/${params.id}/`)
    ) {
      redirect(`/tournaments/${params.id}/overview`)
    }
    if (params.id !== undefined) {
      store.dispatch('competition/initializeCompetition')
      const [eventData] = await Promise.all([
        competitionApi.getSingleEvent(params.id),
      ])
        .then((data) => {
          if (Object.keys(data[0].data).length > 0) {
            store.dispatch('competition/setEventData', data[0].data)
            return [data[0]]
          } else {
            redirect(`/tournaments`)
          }
        })
        .catch((err) => {
          redirect(`/tournaments`)
        })
      return {
        prefetchedData: eventData.data,
      }
    } else {
      return
    }
  },
  data() {
    return {
      // 0 线上 1 线下 2 both
      // 是否显示报名表
      // isShowForm: false,
      // 图片baseurl
      imgUrl: 'https://img.b5csgo.com.cn/',
      showLoginMask: false,
      // 报名表数据
      // formData: {},
      teamMember: [],
      tempStatus: null,
    }
  },
  components: { CompetitionForm, B5Login },
  computed: {
    routeId() {
      return this.$route.params.id
    },
    leftTime() {
      return this.$store.state.competition.leftTime
    },
    overviewData() {
      let obj = this.prefetchedData
      return {
        compOwner: obj.compOwner,
        compAudit: obj.compAudit,
        compApplyQualify: obj.compApplyQualify,
        compApplyNums: obj.compApplyNums,
        compSmallImg: obj.compSmallImg,
      }
    },
    // 赛事状态 立即报名 倒计时 进行中 已完结
    status: {
      get() {
        if (this.tempStatus) {
          return this.tempStatus
        } else if (this.prefetchedData) {
          return this.prefetchedData.compStatus
        } else {
          return 1
        }
      },
      set(newValue) {
        this.tempStatus = newValue
      },
    },
    // 是否登录
    globalLogin() {
      return this.$store.state.app.hasLogin
    },
    // 用户信息
    baseInfo() {
      return this.$store.state.app.baseInfo
    },
  },
  filters: {
    formatDate(val, type) {
      let date = new Date(val * 1000)
      if (type === 1) {
        return date.toLocaleDateString().replace(/\//g, '.')
      } else {
        return date.toLocaleDateString().substring(5).replace(/\//g, '.')
      }
    },
    formatMoney(val) {
      if (!isNaN(+val) && typeof +val == 'number') {
        return `${val} RMB`
      } else {
        return val.trim()
      }
    },
    formatLocation(val) {
      if (+val === 0) {
        return '线上赛'
      } else if (+val === 1) {
        return '线下赛'
      }
      return '线上赛+线下赛'
    },
    formatCompOwner(val) {
      return val.trim()
    },
  },
  created() {
    this.tempStatus = null
    // 登录状态再调用一次接口刷新数据
    if (process.client) {
      if (this.globalLogin) {
        this.getSingleEvent()
      }
    }
  },
  methods: {
    // 获取赛事信息
    async getSingleEvent() {
      let { data } = await competitionApi.getSingleEvent(this.routeId)
      this.$store.dispatch('competition/setEventData', data)
      this.$store.dispatch('competition/setLeftTime', data.leftTime)
      this.prefetchedData = data
    },
    apply() {
      // 未登录弹出登录框
      if (!this.globalLogin) {
        this.showLoginMask = true
        return
      }
      // 登录状态判断是否队长
      // if (this.globalLogin && this.baseInfo.role === 1) {
      this.joinEvent()
      // } else {
      //   // 调用message弹出提示
      //   this.$message({
      //     message: '只有队长才有权限报名',
      //     customClass: 'copy-message',
      //     center: true,
      //     duration: 1000,
      //     offset: 340,
      //   })
      // }
    },
    async joinEvent() {
      let res = await competitionApi.joinEvent(this.routeId)
      if (res.code === 0) {
        window.location.reload(true)
      } else {
        this.$message({
          message: res.msg,
          customClass: 'copy-message',
          center: true,
          duration: 1000,
          offset: 340,
        })
      }
    },
    // 获取报名表
    // async getApplyForm() {
    //   let res = await competitionApi.getApplyForm()
    //   if (res.code === 0) {
    //     let obj = this.prefetchedData
    //     this.formData = {
    //       compAudit: obj.compAudit,
    //       compApplyNums: obj.compApplyNums,
    //       compApplyQualifyDesc: obj.compApplyQualifyDesc,
    //       nodeList: obj.nodeList,
    //       compMinRank: obj.compMinRank,
    //       compRankName: obj.compRankName,
    //     }
    //     this.$store.dispatch('competition/setMemberData', res.data)
    //     this.teamMember = res.data
    //     this.isShowForm = true
    //   } else {
    //     // 获取报名表失败
    //     // 调用message弹出提示
    // this.$message({
    //   message: data.msg,
    //   customClass: 'copy-message',
    //   center: true,
    //   duration: 1000,
    //   offset: 340,
    // })
    //   }
    // },
    // handleEmit(type) {
    //   // this.isShowForm = false
    //   if (type === 1) {
    //     window.location.reload(true)
    //   }
    // },
    changeStatus() {
      this.status = 3
    },
    // 子组件触发关闭事件
    resetShowLogin() {
      this.showLoginMask = false
      location.reload()
    },
  },
}
